const addNewValuation = async () => {
  var myHeaders = new Headers();
  myHeaders.append("Content-type", "application/json");
  myHeaders.append("Authorization", localStorage.getItem("token"));

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(`${process.env.REACT_APP_API_URL}/add_new_valuation`, requestOptions)
    .then((response) => {
      return response.status;
    })
    .catch((error) => {throw new Error(error)});
};

export default addNewValuation;
